/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { PropagateLoader } from 'react-spinners';
import { FaAngleDown } from 'react-icons/fa';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import { getFormattedCurrency, getFormattedNumber } from '~/utils';

import Pagination from '~/components/Pagination';
import DefaultInput from '~/components/Inputs/Default';

import api from '~/services/api';

import { Container, Label, Wrapper, Table, Td } from './styles';

interface ISamplesProps {
  project_id: string;
}

interface IProjectSample {
  id: string;
  total_amount: number;
  sent_amount: number;
  pending_amount: number;
  price: number;
  total_price: number;
  sample: {
    erp_code?: string;
    name: string;
  };
}

const AMOUNT_PER_PAGE = 5;

const Samples: React.FC<ISamplesProps> = ({ project_id }) => {
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState('');
  const [projectSamples, setProjectSamples] = useState<IProjectSample[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const loadProjectSamples = async () => {
      await api
        .get(
          `/projectsamples/project?` +
            `project_id=${project_id}&` +
            `page=${page}&` +
            `filter=${filter}&` +
            `amount=${AMOUNT_PER_PAGE}`,
        )
        .then(response => {
          setProjectSamples(response.data[0]);
          setCount(response.data[1]);
          setLoading(false);
        });
    };

    loadProjectSamples();
  }, [filter, page, project_id]);

  return (
    <Container>
      <Accordion>
        <AccordionSummary expandIcon={<FaAngleDown />}>
          <Label>Amostras</Label>
        </AccordionSummary>

        <AccordionDetails>
          <Wrapper>
            <div>
              <DefaultInput
                name="search"
                labelText="Pesquisar"
                type="text"
                onChange={event => {
                  setFilter(event.target.value);
                  setPage(0);
                }}
              />
            </div>

            <Table>
              <thead>
                <tr>
                  <th style={{ width: '25%', textAlign: 'left' }}>Item</th>
                  <th style={{ width: '15%', textAlign: 'right' }}>
                    Qtd.Total
                  </th>
                  <th style={{ width: '15%', textAlign: 'right' }}>Vlr. Un.</th>
                  <th style={{ width: '15%', textAlign: 'right' }}>
                    Vlr. Total
                  </th>
                  <th style={{ width: '15%', textAlign: 'right' }}>
                    Qtd. Env.
                  </th>
                  <th style={{ width: '15%', textAlign: 'right' }}>
                    Qtd. Pend.
                  </th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <Td
                      colSpan={6}
                      style={{ padding: '3rem', textAlign: 'center' }}
                    >
                      <PropagateLoader color="#276c8d" />
                    </Td>
                  </tr>
                ) : projectSamples.length > 0 ? (
                  projectSamples.map(projectSample => (
                    <tr key={projectSample.id}>
                      <Td heading="ITEM" style={{ width: '25%' }}>
                        {projectSample.sample.name}
                      </Td>
                      <Td
                        heading="QTD. TOTAL"
                        style={{ width: '15%', textAlign: 'right' }}
                      >
                        {getFormattedNumber(
                          projectSample.total_amount,
                          0,
                          false,
                        )}
                      </Td>
                      <Td
                        heading="VLR. UN."
                        style={{ width: '15%', textAlign: 'right' }}
                      >
                        {getFormattedCurrency(projectSample.price)}
                      </Td>
                      <Td
                        heading="VLR. TOTAL"
                        style={{ width: '15%', textAlign: 'right' }}
                      >
                        {getFormattedCurrency(projectSample.total_price)}
                      </Td>
                      <Td
                        heading="QTD. ENV."
                        style={{ width: '15%', textAlign: 'right' }}
                      >
                        {getFormattedNumber(
                          projectSample.sent_amount,
                          0,
                          false,
                        )}
                      </Td>
                      <Td
                        heading="QTD. PEND."
                        style={{ width: '15%', textAlign: 'right' }}
                      >
                        {getFormattedNumber(
                          projectSample.pending_amount,
                          0,
                          false,
                        )}
                      </Td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <Td colSpan={5} style={{ textAlign: 'center' }}>
                      Nenhuma informação disponível
                    </Td>
                  </tr>
                )}
              </tbody>
            </Table>

            <div style={{ display: 'flex', marginTop: '2rem' }}>
              <Pagination
                page={page}
                count={count}
                amountPerPage={AMOUNT_PER_PAGE}
                setPage={setPage}
              />
            </div>
          </Wrapper>
        </AccordionDetails>
      </Accordion>
    </Container>
  );
};

export default Samples;
